/**
 * Sayfa meta bilgisi toplama (AI analizi kapali olsa da calisir).
 *
 * Toplanan alanlar panelde favicon/og:image gostermek ve AI'siz sezgisel sayfa
 * tipi tahmini yapmak icindir. Form degerleri, kullanici metni veya gizli alanlar
 * okunmaz; yalnizca <head> meta etiketleri, ilk H1 ve JSON-LD blogu alinir.
 */

// Yalnizca sayfa tipi/urun cikarimina yarayan semalar saklanir
const ALLOWED_LD_TYPES = [
    "Product",
    "Service",
    "Offer",
    "Article",
    "BlogPosting",
    "NewsArticle",
    "FAQPage",
    "BreadcrumbList",
    "ItemList",
    "CollectionPage",
    "SearchResultsPage",
    "ContactPage",
    "AboutPage",
    "Organization",
    "LocalBusiness",
    "Event",
];

const MAX_JSON_LD_BYTES = 16 * 1024;
const MAX_URL_LENGTH = 500;

function text(value, maxLength) {
    if (value === null || value === undefined) return "";
    return String(value).trim().replace(/\s+/g, " ").slice(0, maxLength || 300);
}

function readMeta(selectors) {
    for (let i = 0; i < selectors.length; i++) {
        try {
            const node = document.querySelector(selectors[i]);
            const content = node && node.getAttribute("content");
            if (content) return text(content, 500);
        } catch (e) {
            /* gecersiz selector yoksayilir */
        }
    }
    return "";
}

function absoluteUrl(href) {
    if (!href) return "";
    try {
        return new URL(href, window.location.href).href.slice(0, MAX_URL_LENGTH);
    } catch (e) {
        return "";
    }
}

/** En buyuk boyutlu <link rel=icon>; yoksa apple-touch-icon, yoksa /favicon.ico */
function resolveFavicon() {
    try {
        const nodes = document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]');
        let best = null;
        let bestSize = -1;

        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const href = node.getAttribute("href");
            if (!href) continue;

            const sizes = String(node.getAttribute("sizes") || "");
            const match = sizes.match(/(\d+)x(\d+)/);
            // rel="icon" olculeri apple-touch-icon'a tercih edilir
            let size = match ? parseInt(match[1], 10) : 0;
            if (!match && String(node.getAttribute("rel") || "").indexOf("apple") !== -1) size = 1;

            if (size > bestSize) {
                bestSize = size;
                best = href;
            }
        }

        if (best) return absoluteUrl(best);
        return absoluteUrl("/favicon.ico");
    } catch (e) {
        return "";
    }
}

function collectJsonLd() {
    const blocks = [];
    const types = [];
    let usedBytes = 0;

    let nodes;
    try {
        nodes = document.querySelectorAll('script[type="application/ld+json"]');
    } catch (e) {
        return { jsonLd: blocks, ldTypes: types };
    }

    for (let i = 0; i < nodes.length; i++) {
        const raw = nodes[i].textContent;
        if (!raw || usedBytes + raw.length > MAX_JSON_LD_BYTES) continue;

        let parsed;
        try {
            parsed = JSON.parse(raw);
        } catch (e) {
            continue;
        }

        // @graph veya dizi kullanimini duzlestir
        const candidates = [].concat(parsed && parsed["@graph"] ? parsed["@graph"] : parsed);
        for (let c = 0; c < candidates.length; c++) {
            const item = candidates[c];
            if (!item || typeof item !== "object") continue;

            const itemTypes = [].concat(item["@type"] || []);
            const allowed = itemTypes.filter(function (type) {
                return ALLOWED_LD_TYPES.indexOf(String(type)) !== -1;
            });
            if (allowed.length === 0) continue;

            const serialized = JSON.stringify(item);
            if (usedBytes + serialized.length > MAX_JSON_LD_BYTES) continue;
            usedBytes += serialized.length;

            blocks.push(item);
            allowed.forEach(function (type) {
                if (types.indexOf(String(type)) === -1) types.push(String(type));
            });
        }
    }

    return { jsonLd: blocks, ldTypes: types };
}

/**
 * @returns {Object} { meta, jsonLd, ldTypes }
 */
export function collectMeta() {
    const ld = collectJsonLd();

    let h1 = "";
    try {
        const node = document.querySelector("h1");
        h1 = node ? text(node.textContent, 200) : "";
    } catch (e) {
        /* yoksay */
    }

    let canonical = "";
    try {
        const node = document.querySelector('link[rel="canonical"]');
        canonical = node ? absoluteUrl(node.getAttribute("href")) : "";
    } catch (e) {
        /* yoksay */
    }

    const meta = {
        title: text(document.title, 300),
        description: readMeta(['meta[name="description"]', 'meta[property="og:description"]']),
        canonical: canonical,
        lang: text((document.documentElement && document.documentElement.lang) || "", 16),
        robots: readMeta(['meta[name="robots"]']),
        ogTitle: readMeta(['meta[property="og:title"]']),
        ogDescription: readMeta(['meta[property="og:description"]']),
        ogImage: absoluteUrl(readMeta(['meta[property="og:image"]', 'meta[name="twitter:image"]'])),
        ogType: readMeta(['meta[property="og:type"]']),
        siteName: readMeta(['meta[property="og:site_name"]']),
        themeColor: readMeta(['meta[name="theme-color"]']),
        favicon: resolveFavicon(),
        h1: h1,
        ldTypes: ld.ldTypes,
    };

    return { meta: meta, jsonLd: ld.jsonLd, ldTypes: ld.ldTypes };
}

/** robots meta'si noindex iceriyor mu (pages.respectNoindex icin). */
export function isNoIndex() {
    const robots = readMeta(['meta[name="robots"]']).toLowerCase();
    return robots.indexOf("noindex") !== -1;
}

export default collectMeta;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/pages/meta.js
// module id = null
// module chunks = 